<script>
  import { authComputed } from '@state/helpers'

  import MetisMenu from 'metismenujs/dist/metismenujs'

  export default {
    components: {},
    computed: {
      ...authComputed,
    },
    mounted: function() {
      // eslint-disable-next-line no-unused-vars
      var menuRef = new MetisMenu('#side-menu')
      var links = document.getElementsByClassName('side-nav-link-ref')
      var matchingMenuItem = null
      for (var i = 0; i < links.length; i++) {
        if (window.location.pathname === links[i].pathname) {
          matchingMenuItem = links[i]
          break
        }
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add('active')
        var parent = matchingMenuItem.parentElement

        /**
         * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
         * We should come up with non hard coded approach
         */
        if (parent) {
          parent.classList.add('active')
          const parent2 = parent.parentElement
          if (parent2) {
            parent2.classList.add('in')
          }
          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.add('active')
            var childAnchor = parent3.querySelector('.has-dropdown')
            if (childAnchor) childAnchor.classList.add('active')
          }

          const parent4 = parent3.parentElement
          if (parent4) parent4.classList.add('in')
          const parent5 = parent4.parentElement
          if (parent5) parent5.classList.add('active')
        }
      }
    },
    methods: {
      /**
       * small sidebar
       */
      smallSidebar() {
        document.body.classList.add('left-side-menu-sm')
        document.body.classList.remove('left-side-menu-dark')
        document.body.classList.remove('topbar-light')
        document.body.classList.remove('boxed-layout')
        document.body.classList.remove('enlarged')
      },

      /**
       * Dark sidebar
       */
      darkSidebar() {
        document.body.classList.remove('left-side-menu-sm')
        document.body.classList.add('left-side-menu-dark')
        document.body.classList.remove('topbar-light')
        document.body.classList.remove('boxed-layout')
      },

      /**
       * Light Topbar
       */
      lightTopbar() {
        document.body.classList.add('topbar-light')
        document.body.classList.remove('left-side-menu-dark')
        document.body.classList.remove('left-side-menu-sm')
        document.body.classList.remove('boxed-layout')
      },

      /**
       * Sidebar collapsed
       */
      sidebarCollapsed() {
        document.body.classList.remove('left-side-menu-dark')
        document.body.classList.remove('left-side-menu-sm')
        document.body.classList.toggle('enlarged')
        document.body.classList.remove('boxed-layout')
        document.body.classList.remove('topbar-light')
      },

      /**
       * Boxed Layout
       */
      boxedLayout() {
        document.body.classList.add('boxed-layout')
        document.body.classList.remove('left-side-menu-dark')
        document.body.classList.add('enlarged')
        document.body.classList.remove('left-side-menu-sm')
      },
    },
  }
</script>

<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul id="side-menu" class="metismenu">
      <li class="menu-title">Navigation</li>

      <li>
        <router-link tag="a" to="/" aria-expanded="false" class="has-dropdown">
          <i class="fe-airplay"></i>
          <span>Dashboard</span>
        </router-link>
      </li>

      <li>
        <router-link tag="a" to="/product/list" aria-expanded="false" class="has-dropdown">
          <i class="fe-layers"></i>
          <span>Products</span>
        </router-link>
      </li>

      <li>
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-pocket"></i>
          <span>Companies</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li>
            <router-link tag="a" to="/company/create" class="side-nav-link-ref">Create user</router-link>
          </li>
          <li>
            <router-link tag="a" to="/company/corporates" class="side-nav-link-ref">Corporates</router-link>
          </li>
          <li>
            <router-link tag="a" to="/company/api-partners" class="side-nav-link-ref">API-Partners</router-link>
          </li>
        </ul>
      </li>


      <li>
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-shopping-cart"></i>
          <span>Orders</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">

          <li>
            <router-link tag="a" to="/orders/orders" class="side-nav-link-ref">All Orders</router-link>
          </li>

          <li>
            <router-link tag="a" to="/orders/success-orders" class="side-nav-link-ref">Success Orders</router-link>
          </li>

          <li>
            <router-link tag="a" to="/orders/pending-orders" class="side-nav-link-ref">Pending Orders</router-link>
          </li>

          <li>
            <router-link tag="a" to="/orders/failed-orders" class="side-nav-link-ref">Failed Orders</router-link>
          </li>
        </ul>
      </li>

      <li>
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-list"></i>
          <span>Fund Request</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li>
            <router-link tag="a" to="/fund-request/pending" class="side-nav-link-ref">Pending Requests</router-link>
          </li>
          <li>
            <router-link tag="a" to="/fund-request/credited" class="side-nav-link-ref">Credited Requests</router-link>
          </li>
          <li>
            <router-link tag="a" to="/fund-request/denied" class="side-nav-link-ref">Denied Requests</router-link>
          </li>
        </ul>
      </li>


      <li>
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-list"></i>
          <span>Reports</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li>
            <router-link tag="a" to="/reports/ledger" class="side-nav-link-ref">Ledger</router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/order-reports" class="side-nav-link-ref">Order Reports</router-link>
          </li>
          <li>
            <router-link tag="a" to="/reports/api-reports" class="side-nav-link-ref">API Reports</router-link>
          </li>
        </ul>
      </li>


      <li>
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-list"></i>
          <span>E-Money</span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li>
            <router-link tag="a" to="/e-money/create" class="side-nav-link-ref">Add E-Money</router-link>
          </li>
          <li>
            <router-link tag="a" to="/e-money/list" class="side-nav-link-ref">E-Money History</router-link>
          </li>
        </ul>
      </li>


      <li class="menu-title mt-1">Admin Control</li>

      <li>
        <router-link tag="a" to="/logout" aria-expanded="false" class="has-dropdown">
          <i class="fe-log-out mr-1"></i>
          <span>Logout</span>
        </router-link>
      </li>


    </ul>
    <div class="clearfix"></div>
  </div>
  <!-- End Sidebar -->
</template>

<style lang="scss">
  @import '~metismenujs/scss/metismenujs';
</style>
